module.exports = __webpack_public_path__ + "static/media/William H. Harrison - 1836.f368f81c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/us/William H. Harrison - 1836.jpg
// module id = 565
// module chunks = 0